import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "@fontsource/space-mono/400.css";
import "@fontsource/space-mono/700.css";
import "@fontsource/vt323/400.css";
import "./index.css";
import "./i18n";

// Initialize Sentry for error tracking and monitoring
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE, // 'production' | 'development'

    // Tag errors by environment for filtering
    initialScope: {
      tags: {
        'test.ci': import.meta.env.VITE_CI === 'true',
        'test.browser': typeof navigator !== 'undefined' && navigator.userAgent.includes('Headless') ? 'playwright' : 'real',
      },
    },

    // Performance Monitoring. Replay is dev-only because rrweb uses
    // Function() construction which would force 'unsafe-eval' in the prod CSP.
    integrations: [
      Sentry.browserTracingIntegration(),
      ...(import.meta.env.DEV
        ? [Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false })]
        : []),
    ],

    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,

    replaysSessionSampleRate: import.meta.env.DEV ? 0.1 : 0,
    replaysOnErrorSampleRate: import.meta.env.DEV ? 1.0 : 0,

    // Add custom context before sending events
    beforeSend(event, hint) {
      // Don't send errors in development unless explicitly enabled
      if (import.meta.env.MODE === 'development' && !import.meta.env.VITE_SENTRY_DEBUG) {
        return null;
      }

      return event;
    },
  });

  // Expose Sentry to window for console testing in development
  if (import.meta.env.MODE === 'development') {
    (window as typeof window & { Sentry: typeof Sentry }).Sentry = Sentry;
    console.log('✅ Sentry initialized and available globally');
    console.log('Dashboard:', 'https://ts4u.sentry.io/issues/');
    console.log('Test with: Sentry.captureException(new Error("Test"))');
  }
} else {
  console.log('ℹ️  Sentry not configured (VITE_SENTRY_DSN not set)');
}

createRoot(document.getElementById("root")!).render(<App />);
